import { StringKey } from '../lang/index';
import { Company } from './company.types';
import { ShareClass } from './share-classes.types';

export enum DilutionCondition {
  EXCLUDE_CAP_TABLE = 'exclude-cap-table',
  INCLUDE_CAP_TABLE = 'include-cap-table',
}

export const DilutionConditionTitle: Record<DilutionCondition, StringKey> = {
  [DilutionCondition.INCLUDE_CAP_TABLE]: 'INCLUDE_CAP_TABLE',
  [DilutionCondition.EXCLUDE_CAP_TABLE]: 'EXCLUDE_CAP_TABLE',
};

export enum SharePlanType {
  BSPCE = 'bspce',
  COMMON_STOCK = 'common-stock',
  GROWTH_HURDLE = 'growth-hurdle',
  PHANTOM = 'phantom',
  RSA = 'rsa',
  RSU = 'rsu',
  SAR = 'sar',
  STOCK_OPTIONS = 'stock-options',
  WARRANTS = 'warrants',
}

export const sharePlanTypeTitle: Record<SharePlanType, StringKey> = {
  [SharePlanType.GROWTH_HURDLE]: 'GROWTH_HURDLE',
  [SharePlanType.STOCK_OPTIONS]: 'STOCK_OPTIONS',
  [SharePlanType.WARRANTS]: 'WARRANT',
  [SharePlanType.SAR]: 'SAR',
  [SharePlanType.RSU]: 'RSU',
  [SharePlanType.PHANTOM]: 'PHANTOM',
  [SharePlanType.RSA]: 'RSA',
  [SharePlanType.COMMON_STOCK]: 'COMMON_STOCK',
  [SharePlanType.BSPCE]: 'BSPCE',
};

/* eslint-disable */
export enum SharePlanVestingType {
  TIME_BASED_STANDARD = 'time-based-standard',
  TIME_BASED_DYNAMIC = 'time-based-dynamic',
  TARGET_BASED = 'target-based',
}
/* eslint-enable */

/* eslint-disable */
export const sharePlanVestingTypeTitle: Record<
  SharePlanVestingType,
  { name: string; description: string }
> = {
  [SharePlanVestingType.TIME_BASED_STANDARD]: { description: 'Standard', name: 'Time Based' },
  [SharePlanVestingType.TIME_BASED_DYNAMIC]: { description: 'Dynamic', name: 'Time Based' },
  [SharePlanVestingType.TARGET_BASED]: { description: 'Standard', name: 'Target Based' },
};
/* eslint-enable */

export enum VestingOnOption {
  FIRST_DATE = 'first-date',
  GRANT_DATE = 'grant-date',
  LAST_DAY = 'last-day',
}

export const VestingOnTitle: Record<VestingOnOption, StringKey> = {
  [VestingOnOption.GRANT_DATE]: 'GRANT_DATE',
  [VestingOnOption.FIRST_DATE]: 'FIRST_DAY_OF_MONTH',
  [VestingOnOption.LAST_DAY]: 'LAST_DAY_OF_MONTH',
};
export enum TerminationInterval {
  MONTH = 'month',
  YEAR = 'year',
}

export const terminationIntervalTitle: Record<TerminationInterval, StringKey> = {
  [TerminationInterval.MONTH]: 'MONTHS',
  [TerminationInterval.YEAR]: 'YEARS',
};

export enum PoolsPlansFilter {
  BY_POOLS = 'by pools',
  BY_STAKEHOLDER = 'by stakeholder',
}

/* eslint-disable */
export enum PoolsPlansSelect {
  NEW_POOL = 'new pool',
  NEW_PLAN = 'new plan',
}
/* eslint-enable */

export type SelectVariant = 'add' | 'export' | PoolsPlansSelect;

export const itemsToFetchMap = [5, 10, 20, 50, 100];

export type SelectNumberOfFetchedItems = number[];

export enum PoolsPlansTableColumn {
  AVAILABLE_POOL = 'available-pool',
  CASH_SETTLED = 'cash-settled',
  DILUTED_SHARES = 'diluted-shares',
  EXERCISABLE = 'exercisable',
  EXERCISED = 'exercised',
  EXPIRED = 'expired',
  GRANT_VESTED = 'total-grant-vested',
  POOL_GRANTED = 'pool-granted',
  RETURNED_TO_POOL = 'returned-to-pool',
  SHARES_VESTED = 'shares-vested',
}

export const PoolsPlansTableColumnTitle: Record<PoolsPlansTableColumn, StringKey> = {
  [PoolsPlansTableColumn.DILUTED_SHARES]: 'DILUTED_SHARES',
  [PoolsPlansTableColumn.AVAILABLE_POOL]: 'AVAILABLE_POOL',
  [PoolsPlansTableColumn.POOL_GRANTED]: 'POOL_GRANTED',
  [PoolsPlansTableColumn.GRANT_VESTED]: 'TOTAL_GRANT_VESTED',
  [PoolsPlansTableColumn.SHARES_VESTED]: 'SHARES_VESTED',
  [PoolsPlansTableColumn.EXERCISABLE]: 'EXERCISABLE',
  [PoolsPlansTableColumn.EXERCISED]: 'EXERCISED',
  [PoolsPlansTableColumn.CASH_SETTLED]: 'CASH_SETTLED',
  [PoolsPlansTableColumn.RETURNED_TO_POOL]: 'RETURNED_TO_POOL',
  [PoolsPlansTableColumn.EXPIRED]: 'EXPIRED',
};

export enum StakeholderPoolsPlansTableColumn {
  CASH_SETTLED = 'cash-settled',
  EXERCISABLE = 'exercisable',
  EXERCISED = 'exercised',
  EXPIRED = 'expired',
  GRANT_VESTED = 'total-grant-vested',
  POOL_GRANTED = 'pool-granted',
  RETURNED_TO_POOL = 'returned to pool',
  SHARES_VESTED = 'shares-vested',
}

export enum PoolPlansTab {
  ACTIVE = 'active',
  TERMINATED = 'terminated',
}

export const StakeholderPoolsPlansTableColumnTitle: Record<
  StakeholderPoolsPlansTableColumn,
  StringKey
> = {
  [StakeholderPoolsPlansTableColumn.POOL_GRANTED]: 'POOL_GRANTED',
  [StakeholderPoolsPlansTableColumn.GRANT_VESTED]: 'TOTAL_GRANT_VESTED',
  [StakeholderPoolsPlansTableColumn.SHARES_VESTED]: 'SHARES_VESTED',
  [StakeholderPoolsPlansTableColumn.EXERCISABLE]: 'EXERCISABLE',
  [StakeholderPoolsPlansTableColumn.EXERCISED]: 'EXERCISED',
  [StakeholderPoolsPlansTableColumn.CASH_SETTLED]: 'CASH_SETTLED',
  [StakeholderPoolsPlansTableColumn.RETURNED_TO_POOL]: 'RETURNED_TO_POOL',
  [StakeholderPoolsPlansTableColumn.EXPIRED]: 'EXPIRED',
};

export enum ExerciseType {
  BSPCE = 'bspce',
  HURDLE = 'hurdle',
  PHANTOM = 'phantom',
  SAR = 'sar',
  STOCK_OPTIONS = 'stock-options',
  // RSA = 'rsa',
  WARRANTS = 'warrants',
}

export const sharePlanToExerciseMap: Record<SharePlanType, ExerciseType> = {
  [SharePlanType.STOCK_OPTIONS]: ExerciseType.STOCK_OPTIONS,
  [SharePlanType.WARRANTS]: ExerciseType.WARRANTS,
  [SharePlanType.SAR]: ExerciseType.SAR,
  [SharePlanType.GROWTH_HURDLE]: ExerciseType.HURDLE,
  [SharePlanType.PHANTOM]: ExerciseType.PHANTOM,
  [SharePlanType.BSPCE]: ExerciseType.BSPCE,
  [SharePlanType.COMMON_STOCK]: ExerciseType.BSPCE,
  [SharePlanType.RSA]: ExerciseType.BSPCE,
  [SharePlanType.RSU]: ExerciseType.BSPCE,
};

export const ExerciseTypeTitle: Record<ExerciseType, StringKey> = {
  [ExerciseType.STOCK_OPTIONS]: 'EXERCISE_STOCK_OPTIONS',
  // [ExerciseType.RSA]: "EXERCISE_RSA",
  [ExerciseType.WARRANTS]: 'EXERCISE_EXPIRE_WARRANTS',
  [ExerciseType.SAR]: 'EXERCISE_SAR',
  [ExerciseType.HURDLE]: 'APPROVE_HURDLE',
  [ExerciseType.PHANTOM]: 'PAYOUT_PHANTOM',
  [ExerciseType.BSPCE]: 'EXERCISE_BSPCE',
};

export enum ExerciseTab {
  EXERCISE = 'exercise',
  EXPIRE = 'expire',
}

export type CreatePoolDto = {
  additionalNotes?: string;
  capTableInclusion: boolean;
  date: string;
  dillutedSharesCount: number;
  filesLinks: string[];
  name: string;
  shareClassId: string;
};

export type PatchPoolDto = {
  additionalNotes?: string;
  capTableInclusion?: boolean;
  date?: string;
  filesLinks?: string[];
  name?: string;
  shareClassId?: string;
};
export type TerminatePoolDto = {
  date: string;
};

export type Pool = {
  additionalNotes: string;
  capTableInclusion: boolean;
  cashSettled: number;
  date: Date;
  dillutedSharesCount: number;
  docusignFileLinks?: string[];
  exercisable: number;
  exercised: number;
  expired: number;
  filesLinks: string[];
  granted: number;
  id: string;
  isTerminated: boolean;
  name: string;
  returnedToPool: number;
  shareClass: ShareClass;
  sharePlansCount: number;
  sharesVested: number;
  terminationDate?: Date;
  totalGrantVested: number;
};

export interface VestingSettingsCommon {
  type: SharePlanVestingType;
}

export interface TimeBasedStandardVestingSettings extends VestingSettingsCommon {
  accelarationDate: Date;
  cliffMonths: number;
  durationMonths: number;
  frequencyMonths: number;
  type: SharePlanVestingType.TIME_BASED_STANDARD;
  vestingOn: VestingOnOption;
}

export interface TimeBasedDynamicVestingPeriod {
  durationMonths: number;
  frequencyMonths: number;
  planAllocation: number;
}

export interface TimeBasedDynamicVestingSettings extends VestingSettingsCommon {
  accelarationDate: Date;
  periods: TimeBasedDynamicVestingPeriod[];
  type: SharePlanVestingType.TIME_BASED_DYNAMIC;
  vestingOn: VestingOnOption;
}

export interface TargetBasedVestingMilestone {
  name: string;
  targetDate: Date;
  weight: number;
}

export interface TargetBasedVestingSettings extends VestingSettingsCommon {
  milestones: TargetBasedVestingMilestone[];
  type: SharePlanVestingType.TARGET_BASED;
}

export type VestingSettingsUnion =
  | TargetBasedVestingSettings
  | TimeBasedDynamicVestingSettings
  | TimeBasedStandardVestingSettings;

export enum TerminationCause {
  DEATH = 'death',
  DISABILITY = 'disability',
  RESIGNATION = 'resignation',
  RETIREMENT = 'retirement',
  TERMINATION = 'termination',
  TERMINATION_WITH_CAUSE = 'termination-with-cause',
}

export interface TerminationSpecifier {
  interval: TerminationInterval;
  value: number;
}

export type TerminationLogic = Record<TerminationCause, null | TerminationSpecifier>;

export interface SharePlanCommon {
  additionalNotes?: string;
  cashSettled: number;
  date: Date;
  docusignFileLinks?: string[];
  exercisable: number;
  exercised: number;
  expired: number;
  filesLinks: string[];
  granted: number;
  id: string;
  isTerminated: boolean;
  name: string;
  pool: Pool;
  returnedToPool: number;
  sharesVested: number;
  terminationDate?: Date;
  terminationLogic?: TerminationLogic;
  totalGrantVested: number;
  type: SharePlanType;
  vesting?: VestingSettingsUnion;
}

export interface ConvertionableSharePlan {
  conversionRatio: number;
}

export interface GrowthHurdleSharePlan extends SharePlanCommon {
  hardleValue: number;
  type: SharePlanType.GROWTH_HURDLE;
}

export interface StockOptionsSharePlan extends SharePlanCommon, ConvertionableSharePlan {
  strikePrice: number;
  type: SharePlanType.STOCK_OPTIONS;
}

export interface WarrantsSharePlan extends SharePlanCommon, ConvertionableSharePlan {
  expiryDate?: Date;
  type: SharePlanType.WARRANTS;
  warrantPrice: number;
}

export interface SARSharePlan extends SharePlanCommon {
  sarBasePrice: number;
  type: SharePlanType.SAR;
}

export interface RSUSharePlan extends SharePlanCommon, ConvertionableSharePlan {
  type: SharePlanType.RSU;
}

export interface PhantomSharePlan extends SharePlanCommon, ConvertionableSharePlan {
  type: SharePlanType.PHANTOM;
}

export interface RSASharePlan extends SharePlanCommon, ConvertionableSharePlan {
  rsaPurchasePrice?: number;
  type: SharePlanType.RSA;
}

export interface CommonStockSharePlan extends SharePlanCommon {
  type: SharePlanType.COMMON_STOCK;
}

export interface BSPCESharePlan extends SharePlanCommon, ConvertionableSharePlan {
  strikePrice: number;
  type: SharePlanType.BSPCE;
}

export type SharePlanUnionType =
  | BSPCESharePlan
  | CommonStockSharePlan
  | GrowthHurdleSharePlan
  | PhantomSharePlan
  | RSASharePlan
  | RSUSharePlan
  | SARSharePlan
  | StockOptionsSharePlan
  | WarrantsSharePlan;

export type AutomaticVestingSharePlanUnionType =
  | CommonStockSharePlan
  | GrowthHurdleSharePlan
  | PhantomSharePlan
  | RSUSharePlan
  | SARSharePlan;

export type AutomaticVestingSharePlan =
  | SharePlanType.COMMON_STOCK
  | SharePlanType.PHANTOM
  | SharePlanType.RSA
  | SharePlanType.RSU;

export const automaticVestingSharePlanTypeMap: AutomaticVestingSharePlan[] = [
  SharePlanType.RSU,
  SharePlanType.COMMON_STOCK,
  SharePlanType.PHANTOM,
  SharePlanType.RSA,
];

export type ExercisableVestingSharePlan =
  | SharePlanType.BSPCE
  | SharePlanType.GROWTH_HURDLE
  // | SharePlanType.RSA
  | SharePlanType.SAR
  | SharePlanType.STOCK_OPTIONS
  | SharePlanType.WARRANTS;

export const exercisableVestingSharePlanTypeMap: ExercisableVestingSharePlan[] = [
  SharePlanType.STOCK_OPTIONS,
  SharePlanType.WARRANTS,
  // SharePlanType.RSA,
  SharePlanType.GROWTH_HURDLE,
  SharePlanType.SAR,
  SharePlanType.BSPCE,
];

export type DefinedSharePlan<T extends SharePlanType> = Extract<SharePlanUnionType, { type: T }>;

export type TargetBasedMilestone = {
  isComplete: boolean;
  name: string;
  sharePlanId: string;
  targetDate: Date;
  weight: number;
};

export type SharePlan = {
  additionalNotes: string;
  basePrice?: number;
  company: Company;
  conversionRatio?: number;
  date: Date;
  docusignFileLinks?: string[];
  expiryDate?: Date;
  filesLinks: string[];
  hardleValue?: number;
  id: string;
  isTerminated: boolean;
  name: string;
  pool: Pool;
  rsaPurchasePrice?: number;
  sarBasePrice?: number;
  strikePrice?: number;
  terminationDate?: Date;
  terminationLogic?: TerminationLogic;
  type: SharePlanType;
  vesting?: VestingSettingsUnion;
  warrantPrice?: number;
};
export type TerminationSpecifierDto = {
  interval: TerminationInterval;
  value: number;
};

export type TerminationLogicDto = {
  [TerminationCause.DEATH]: null | TerminationSpecifierDto;
  [TerminationCause.DISABILITY]: null | TerminationSpecifierDto;
  [TerminationCause.RESIGNATION]: null | TerminationSpecifierDto;
  [TerminationCause.RETIREMENT]: null | TerminationSpecifierDto;
  [TerminationCause.TERMINATION]: null | TerminationSpecifierDto;
  [TerminationCause.TERMINATION_WITH_CAUSE]: null | TerminationSpecifierDto;
};

export type TimeBasedDynamicVestingPeriodDto = {
  durationMonths: number;
  frequencyMonths: number;
  planAllocation: number;
};

export type TargetBasedVestingMilestoneDto = {
  name: string;
  targetDate: string;
  weight: number;
};

export type VestingSettingsDto = {
  accelarationDate?: string;
  cliffMonths?: number;
  durationMonths?: number;
  frequencyMonths?: number;
  milestones?: TargetBasedVestingMilestoneDto[];
  periods?: TimeBasedDynamicVestingPeriodDto[];
  type: SharePlanVestingType;
  vestingOn?: VestingOnOption;
};

export type CreateSharePlanDto = {
  additionalNotes?: string;
  conversionRatio?: number;
  date: string;
  expiryDate?: null | string;
  filesLinks: string[];
  hardleValue?: number;
  name: string;
  poolId: string;
  rsaPurchasePrice?: number;
  sarBasePrice?: number;
  strikePrice?: number;
  terminationLogic: null | TerminationLogicDto;
  type: SharePlanType;
  vesting: null | VestingSettingsDto;
  warrantPrice?: number;
};

export type PatchSharePlanDto = {
  additionalNotes?: string;
  conversionRatio?: number;
  date?: string;
  expiryDate?: null | string;
  filesLinks?: string[];
  hardleValue?: number;
  name?: string;
  poolId?: string;
  rsaPurchasePrice?: number;
  sarBasePrice?: number;
  strikePrice?: number;
  terminationLogic?: null | TerminationLogicDto;
  type?: SharePlanType;
  vesting?: null | VestingSettingsDto;
  warrantPrice?: number;
};
